<template>
  <div class="property-tab">
    <div class="property-title">Name:</div>
    <v-text-field
      v-model="entryName"
      hide-details
      single-line
      variant="outlined"
      density="compact"
      class="field-bordered"
      :disabled="PreferenceStore.INSTANCE.isReadOnly"
      @focus="onFocus"
      @blur="onBlur"
    ></v-text-field>
    <div v-if="isEntry">
      <div class="property-title">Type:</div>
      <v-select
        :model-value="selected"
        :items="items"
        density="compact"
        persistent-hint
        variant="outlined"
        class="field-bordered"
        :disabled="PreferenceStore.INSTANCE.isReadOnly"
        @update:modelValue="entryTypeChanged"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type NamedElement from "../mvc/base/named-element";
import { Entry } from "../mvc/entry";
import { computed, inject, onMounted, onBeforeUnmount } from "vue";
import { PreferenceStore } from "../services/preference-store";
import RappidContext from "../rappid/rappid-context";

const rappidContext: RappidContext = inject<RappidContext>("rappidContext");
const items: string[] = ["Initial", "ShallowHistory", "DeepHistory"];

const compProps = defineProps<{
  model: NamedElement;
}>();

const emit = defineEmits(["entry-type-change", "notifyChange"]);

const changeNotifier = (model) => {
  emit("notifyChange", model);
};

onMounted(() => {
  compProps.model.on("change", changeNotifier, compProps.model);
});

onBeforeUnmount(() => {
  compProps.model.off("change", changeNotifier);
});

const selected = computed(() => {
  if (compProps.model instanceof Entry) {
    return compProps.model.get("entryKind");
  }
  return "unknown";
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function entryTypeChanged(value: any) {
  emit("entry-type-change", value);
}

const entryName = computed({
  get(): string {
    return compProps.model.getName();
  },
  set(name: string) {
    compProps.model.setName(name);
    emit("notifyChange", compProps.model);
  },
});

function onFocus() {
  rappidContext.commandManager.initBatchCommand();
}

function onBlur() {
  rappidContext.commandManager.storeBatchCommand();
}

const isEntry = computed(() => {
  return compProps.model instanceof Entry;
});
</script>
